var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function GitLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 40 40" }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M3.811 17.682a3.28 3.28 0 0 0 0 4.637l13.871 13.87a3.28 3.28 0 0 0 4.637 0l13.87-13.87a3.28 3.28 0 0 0 0-4.637L22.319 3.811a3.28 3.28 0 0 0-4.637 0l-2.975 2.975 4.119 4.248a2.79 2.79 0 0 1 3.667 3.782l3.344 3.449a2.788 2.788 0 1 1 1.028 5.382 2.79 2.79 0 0 1-2.564-3.888l-3.228-3.338v8.298a2.79 2.79 0 1 1-2.145 0V16.14a2.791 2.791 0 0 1-1.547-3.536l-4.175-4.317-9.395 9.395z", fillRule: "evenodd", clipRule: "evenodd" }) })));
}
export default GitLogomark;
